export const colorConfig = [{
  org: '工程学院',
  color: 'background-color:#6FC8EC'
},
{
  org: '食品学院',
  color: 'background-color:#1E9493'
},
{
  org: '电子工程学院',
  color: 'background-color:#FF99C3'
},
{
  org: '农学院',
  color: 'background-color:#5AD8A6'
},
{
  org: '数学与信息学院、软件学院',
  color: 'background-color:#F6BD16'
},
{
  org: '材料与能源学院',
  color: 'background-color:#F54E35'
},
{
  org: '资源环境学院',
  color: 'background-color:#E68A00'
},
{
  org: '兽医学院',
  color: 'background-color:#2E9DD9'
},
{
  org: '动物科学学院',
  color: 'background-color:#2E9DD9'
},
{
  org: '林学与风景园林学院',
  color: 'background-color:#80CBCF'
}
]
